module.exports = __webpack_public_path__ + "fa8d8106813bcc29c6e8a3e2eff7470f.png";